import Vue from 'vue'
import VueGtag from 'vue-gtag'

export default ({ store, app, $config }) => {
  // Set up Google consent mode defaults before loading any tags
  if (process.client && window) {
    window.dataLayer = window.dataLayer || [];
    function gtag () { window.dataLayer.push(arguments); }

    // Set default consent - denied by default until explicit consent is given
    gtag('consent', 'default', {
      'analytics_storage': 'denied',
      'ad_storage': 'denied',
      'personalization_storage': 'denied',
      'functionality_storage': 'denied',
      'security_storage': 'granted' // Security is typically always granted
    });
  }
  let includes = []
  if ($config.production) {
    includes = [
      { id: $config.adsTrackingId },
      { id: $config.gaMeasurementId }
    ]
  }
  Vue.use(VueGtag, {
    includes,
    config: {
      debug: !$config.production,
      id: $config.gaMeasurementId
    },
    appName: process.env.PROJECT,
    bootstrap: true, // Always bootstrap but respect consent
    enabled: store.state.cookie.consents.analytics,
    pageTrackerTemplate: to => to.fullPath
  }, app.router)
  // Update consent state when available from store
  if (process.client && window && store.state.cookie.consents) {
    const consents = store.state.cookie.consents;
    window.gtag && window.gtag('consent', 'update', {
      'analytics_storage': consents.analytics ? 'granted' : 'denied',
      'ad_storage': consents.marketing ? 'granted' : 'denied',
      'personalization_storage': consents.personalization ? 'granted' : 'denied',
      'functionality_storage': consents.functional ? 'granted' : 'denied'
    });
  }
  // Subscribe to changes in the consent state
  store.subscribe((mutation, state) => {
    if (mutation.type === 'cookie/setConsents' && process.client && window.gtag) {
      const consents = state.cookie.consents;
      window.gtag('consent', 'update', {
        'analytics_storage': consents.analytics ? 'granted' : 'denied',
        'ad_storage': consents.marketing ? 'granted' : 'denied',
        'personalization_storage': consents.personalization ? 'granted' : 'denied',
        'functionality_storage': consents.functional ? 'granted' : 'denied'
      });
    }
  });
}
